module.exports = __webpack_public_path__ + "img/background-branch-detail.684fe918.svg";